import { FunctionComponent } from "react";
import { useTranslation } from "react-i18next";

export type Section4Type = {
  className?: string;
};

const Section4: FunctionComponent<Section4Type> = ({ className = "" }) => {
  const { t } = useTranslation();

  return (
    <section
      className={`
        self-stretch bg-whitesmoke overflow-hidden
        flex flex-col lg:flex-row items-center justify-center
        gap-8 px-6 py-12
        max-w-full text-left text-xl text-black font-inter
        ${className}
      `}
    >
      {/* LEFT BLOCK */}
      <div
        className={`
          flex-1 flex flex-col justify-center
          py-[68.5px] px-[50px] box-border gap-5
          max-w-[640px]
          lg:items-start lg:text-left
          items-center text-center
          mq450:py-[29px]
        `}
      >
        <div className="w-full text-xl text-cornflowerblue font-medium">
          {t("section4.title")}
        </div>
        <h1
          className="
            m-0 w-full max-w-[639px] text-41xl font-semibold leading-tight
            mq450:text-29xl
          "
        >
          {t("section4.heading")}
        </h1>

        {/* Features positioned below the title */}
        <div
          className={`
            flex flex-col gap-4
            w-full max-w-[500px]
            lg:items-start items-center
          `}
        >
          {/* Feature 1 */}
          <div className="flex items-start gap-4">
            <img
              src="/landing/20240809-124049-1@2x.png"
              alt={t("section4.featureIcon") || ""}
              className="w-7 h-7 object-cover mt-1"
            />
            <div className="flex flex-col">
              <span className="text-lg font-bold">
                {t("section4.feature1.title") || ""}
              </span>
              <span className="text-base">
                {t("section4.feature1.description")}
              </span>
            </div>
          </div>

          {/* Feature 2 */}
          <div className="flex items-start gap-4">
            <img
              src="/landing/20240809-124049-1@2x.png"
              alt={t("section4.featureIcon") || ""}
              className="w-7 h-7 object-cover mt-1"
            />
            <div className="flex flex-col">
              <span className="text-lg font-bold">
                {t("section4.feature2.title")}
              </span>
              <span className="text-base">
                {t("section4.feature2.description")}
              </span>
            </div>
          </div>

          {/* Feature 3 */}
          <div className="flex items-start gap-4">
            <img
              src="/landing/20240809-124049-1@2x.png"
              alt={t("section4.featureIcon") || ""}
              className="w-7 h-7 object-cover mt-1"
            />
            <div className="flex flex-col">
              <span className="text-lg font-bold">
                {t("section4.feature3.title")}
              </span>
              <span className="text-base">
                {t("section4.feature3.description")}
              </span>
            </div>
          </div>
        </div>
      </div>

      {/* RIGHT BLOCK (IMAGE) */}
      <div
        className="
          flex-1 flex items-center justify-start
          max-w-[545px]
        "
      >
        <img
          className="
            w-full max-w-full h-auto object-cover
          "
          loading="lazy"
          alt={t("section4.visualAlt") || ""}
          src="/landing/section-4.svg"
        />
      </div>
    </section>
  );
};

export default Section4;
